import {
  JobsApiClientInterface,
  JobsApiClientModel,
  JobsApiClientUrlsInterface,
  // JobsApiClientOptions,
} from '../../../models/api-client/models';
//import {config} from '../../../config';
const urls: JobsApiClientUrlsInterface = {
  fetchJobs: '/static/mock-data/jobs/jobs.json',
};
// instantiate the ItemsApiClient pointing at the url that returns static json mock \
//data
const jobsApiClient: JobsApiClientInterface = new JobsApiClientModel({
  urls,
  mockDelay: 1000,
});
// export our instance
export {jobsApiClient};
